import { Helmet } from 'react-helmet-async';

const SchemaMarkup = ({ data }) => {
  if (!data) return null;
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
